export default "__VITE_ASSET__C_xbWzeW__"